import { render } from "./SimpleStudentCard.vue?vue&type=template&id=4ff0267e&scoped=true"
import script from "./SimpleStudentCard.vue?vue&type=script&lang=js"
export * from "./SimpleStudentCard.vue?vue&type=script&lang=js"

import "./SimpleStudentCard.vue?vue&type=style&index=0&id=4ff0267e&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff0267e"]])

export default __exports__